import apiClient from './client'

/**
 * Inicia sesión con username y password
 */
export const login = async (username, password) => {
  const response = await apiClient.post('/api/IniciarSesion', {
    username,
    password,
  })

  // La respuesta tiene estructura: { code, payload, message }
  // El payload contiene el token y datos del usuario
  return response.data
}

/**
 * Cierra sesión (local, no hay endpoint de logout)
 */
export const logout = () => {
  // Solo limpiamos el localStorage
  return Promise.resolve()
}
